import { render, staticRenderFns } from "./ProjektDetails.vue?vue&type=template&id=4b172f3b&"
import script from "./ProjektDetails.vue?vue&type=script&lang=js&"
export * from "./ProjektDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports